import apiService from '../apiService'
export const mySupplierCompanyController = configService => {
  const service = apiService(configService)
  return {
    getBusinessType: () => {
      return service.get({
        url: `cms/supplier/business-type`,
      })
    },

    getMySupplierCompany: () => {
      return service.get({
        url: 'cms/supplier/my-supplier-company',
      })
    },

    getBusinessCategories: () => {
      return service.get({
        url: `cms/supplier/category`,
      })
    },

    getBusinessSubCategories: id => {
      return service.get({
        url: `cms/supplier/category/${id}/sub-category`,
      })
    },

    updateSupplierSupplier: params => {
      return service.putFormData({
        url: `cms/supplier/my-supplier-company`,
        params,
      })
    },

    downloadAttachment: id => {
      return service.downloadFile({
        url: `cms/supplier/my-supplier-company-file/${id}`,
      })
    },

    downloadAttachmentRegistration: id => {
      return service.downloadFile({
        url: `auth/supplier/my-supplier-company-file/${id}`,
      })
    },

    getRFQSupplierList: params => {
      const strSearch = encodeURIComponent(params.eventName)
      return service.get({
        url: `cms/supplier/event?event_no_and_name=${strSearch}&status_id=${params.statusId}&company_id=${params.buyerId}&response_status_id=${params.responseStatusId}&page=${params.page}&limit=${params.limit}&sort_by=${params.sort_by}&sort_direction=${params.sort_direction}&event_type_id=${params.event_type_id}`,
        // url: `cms/supplier/event?event_no_and_name=${strSearch}&status_id=${params.statusId}&company_id=${params.buyerId}&response_status_id=${params.responseStatusId}&page=1&limit=${params.limit}&sort_by=${params.sort_by}&sort_direction=${params.sort_direction}&event_type_id=${params.event_type_id}`,
      })
    },

    getRFQEvent: id => {
      return service.get({
        url: `cms/supplier/event/${id}`,
      })
    },

    getRFQSupplierID: id => {
      return service.get({
        url: `cms/supplier/rfq/${id}`,
      })
    },

    getAuctionSupplierID: id => {
      return service.get({
        url: `cms/supplier/auction/${id}`,
      })
    },

    getRFQSupplier: id => {
      return service.get({
        url: `cms/supplier/rfq/${id}/supplier`,
      })
    },

    getAuctionSupplier: id => {
      return service.get({
        url: `cms/supplier/auction/${id}/supplier`,
      })
    },

    getRFQBuyer: id => {
      return service.get({
        url: `cms/supplier/rfq/${id}/buyer-company`,
      })
    },
    getBuyerCompany: event_id => {
      return service.get({
        url: `cms/supplier/event/${event_id}/buyer/company`,
      })
    },

    getEventStatus: () => {
      return service.get({
        url: `cms/supplier/event/status`,
      })
    },

    getResponseStatus: () => {
      return service.get({
        url: `cms/supplier/event/response-status`,
      })
    },

    getBuyerStatuses: () => {
      return service.get({
        url: `cms/supplier/event/buyer/company`,
      })
    },

    getRFQItem: rfq_id => {
      return service.get({
        url: `cms/supplier/rfq/${rfq_id}/item-supplier`,
      })
    },

    getAuctionItem: auction_id => {
      return service.get({
        url: `cms/supplier/auction/${auction_id}/item-supplier`,
      })
    },

    getRFQSupplierItem: (rfq_id, params) => {
      // return service.get({
      //   url: `cms/supplier/rfq/${rfq_id}/item-supplier/page`,
      //   params,
      // })

      return service.get({
        url: `cms/supplier/event/${rfq_id}/item`,
        params,
      })
    },

    // getDownloadFileBuyerInfo: rfq_id => {
    //   return service.get({
    //     url: `cms/supplier/rfq/${rfq_id}/external`,
    //   })
    // },

    // getDownloadFileBuyerInfoAuction: auction_id => {
    //   return service.get({
    //     url: `cms/supplier/auction/${auction_id}/external`,
    //   })
    // },

    getEventFileBuyerInfo: event_id => {
      return service.get({
        url: `cms/supplier/event/${event_id}/file/external`,
      })
    },

    // downloadFileBuyerInfo: id => {
    //   return service.downloadFile({
    //     url: `/cms/supplier/rfq/external/${id}/download`,
    //   })
    // },

    // downloadFileBuyerInfoAuction: id => {
    //   return service.downloadFile({
    //     url: `/cms/supplier/auction/external/${id}/download`,
    //   })
    // },

    downloadFileBuyerInfoEvent: id => {
      return service.downloadFile({
        url: `/cms/supplier/event/file/external/${id}`,
      })
    },

    getRFQSupplierHistory: id => {
      return service.get({
        url: `/cms/supplier/rfq/${id}/histories`,
      })
    },

    getAuctionSupplierHistory: id => {
      return service.get({
        url: `/cms/supplier/auction/${id}/histories`,
      })
    },

    saveDraft: params => {
      return service.putFormData({
        url: `cms/supplier/rfqSupplier/saveDraft`,
        params,
      })
    },

    downloadFileItem: id => {
      return service.downloadFile({
        url: `cms/supplier/event/item/file/${id}`,
      })
    },
    downloadSupplierFileItem: id => {
      return service.downloadFile({
        url: `cms/supplier/rfq/supplier/item/file/${id}`,
      })
    },

    onClickAccept: params => {
      return service.put({
        url: `cms/supplier/rfq/rfqSupplier/accept`,
        params,
      })
    },
    //onClickAcceptResponse
    onClickAcceptResponse: params => {
      return service.acceptResponse({
        url: `cms/supplier/rfq/rfqSupplier/accept`,
        params,
      })
    },

    onClickAcceptResponseAuction: params => {
      return service.acceptResponse({
        url: `cms/supplier/auction/auctionSupplier/accept`,
        params,
      })
    },

    onClickSaveDraft: params => {
      return service.put({
        url: `cms/supplier/rfq/rfqSupplier/saveDraft`,
        params,
      })
    },

    onClickReject: params => {
      return service.put({
        url: `cms/supplier/rfq/rfqSupplier/reject`,
        params,
      })
    },

    // onClickRejectTimeOut
    onClickRejectTimeOut: params => {
      return service.onClickRejectTimeOut({
        url: `cms/supplier/rfq/rfqSupplier/reject`,
        params,
      })
    },
    onClickRejectTimeOutAuction: params => {
      return service.put({
        url: `cms/supplier/auction/auctionSupplier/reject`,
        params,
      })
    },

    getReason: () => {
      return service.get({
        url: `cms/supplier/rfq/reject-reason`,
      })
    },

    getReasonAuction: () => {
      return service.get({
        url: `cms/supplier/auction/reject-reason`,
      })
    },

    rfqSupplierItemFile: params => {
      return service.postFormData({
        url: 'cms/supplier/rfq/rfqSupplierItemFile',
        params,
      })
    },

    acceptTermCondition: event_id => {
      return service.post({
        url: `cms/supplier/event/${event_id}/terms-and-conditions`,
      })
    },

    getSupplierEventFile: event_id => {
      return service.get({
        url: `cms/supplier/event/${event_id}/supplier/file`,
      })
    },

    rfqSupplierEventFile: params => {
      return service.postFormData({
        url: 'cms/supplier/rfq/supplier-file',
        params,
      })
    },

    downloadSupplierEventFile: id => {
      return service.downloadFile({
        url: `cms/supplier/event/supplier/file/${id}`,
      })
    },

    uploadProductItem: formData => {
      return service.uploadFile({
        url: `cms/supplier/rfq/item/import-excel/upload`,
        formData,
      })
    },
    downloadProductItem: (rfq_supplier_id, currency_name) => {
      return service.downloadFile({
        url: `cms/supplier/rfq/item/export-excel/${rfq_supplier_id}/${currency_name}/download`,
      })
    },
    getOnlineTemplate: id => {
      return service.getNew({
        url: 'cms/supplier/online-templates',
      })
    },
    getSupplierHistory: event_id => {
      return service.get({
        url: `cms/supplier/event/${event_id}/histories`,
      })
    },
    getVerifyToken: token => {
      return service.get({
        url: `cms/supplier/verify/email/token?token=${token}`,
      })
    },
  }
}
